import { createSlice } from '@reduxjs/toolkit';
import { OverlayType } from './interface';
import { DEFAULT_APP_OVERLAY_CONFIG, DEFAULT_OVERLAY_DISPLAY_CONFIG } from './constants';
export const initialOverlayConfigState = {
  appOverlayDisplayConfig: DEFAULT_APP_OVERLAY_CONFIG,
  overlayType: OverlayType.MODAL,
  isOverlayOpen: false,
  shouldShowToolbar: true,
  shouldShowNav: true
};
export const overlayDisplayConfigSlice = createSlice({
  name: 'overlayDisplayConfig',
  initialState: initialOverlayConfigState,
  reducers: {
    appOverlayDisplayConfig: (state, action) => {
      state.appOverlayDisplayConfig = Object.assign({}, action.payload, {
        isInitialized: true
      });
    },
    toolbarAndNavDisplayConfig: (state, action) => {
      state.isOverlayOpen = action.payload.isOverlayOpen;
      state.overlayType = action.payload.overlayType;
      if (!action.payload.isOverlayOpen) {
        state.shouldShowToolbar = true;
        state.shouldShowNav = true;
      } else if (action.payload.isOverlayOpen && action.payload.overlayType) {
        const overlayDisplayConfig = state.appOverlayDisplayConfig[action.payload.overlayType] || DEFAULT_OVERLAY_DISPLAY_CONFIG;
        state.shouldShowToolbar = overlayDisplayConfig.shouldShowToolbar;
        state.shouldShowNav = overlayDisplayConfig.shouldShowNav;
      }
    }
  }
});
export default overlayDisplayConfigSlice.reducer;